import ManaParticle from "../../../ManaParticle"
import InvertableManaNode, { InvertableManaNodeOptions } from "../../InvertableManaNode"
import NodeCategories from "../../NodeCategories"

export type VelocityDirectionOptions = {} & InvertableManaNodeOptions

export default class VelocityDirectionNode extends InvertableManaNode {


	static nodeType = 'VelocityDirection'
	static nodeName = "Velocity direction node"
	static nodeDesc = "Sets particle direction towards the target's velocity"
	static nodeIcon = '☄'
	static category = NodeCategories.Direction

	onScroll(dir: number) { }

	async act(particle: ManaParticle) {
		if (particle.target) {
			particle.direction = particle.target.velocity.clone().rotateDeg(this.inverted ? 180 : 0).norm()
		}

		return true
	}

}